import { BasicListProps } from "/Models/Generated/BasicListProps";

export type BasicListResult =
  | BasicListProps
  | { error?: boolean; message?: string };
export default class BasicListClient {
  constructor(private endpoint?: string) {}

  public GetMoreBasicItems = (
    basicListPageId: number,
    language: string,
    lastItemId: number,
    isFromCollection: boolean,
  ): Promise<BasicListResult> => {
    return fetch(
      `${this.endpoint}?basicListPageId=${basicListPageId}&language=${language}&lastItemId=${lastItemId}&lastItemIdIsFromCollection=${isFromCollection}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error from event list API");
        }
        return response.json();
      })
      .catch((error) => {
        //gracefull return
        return { error: true, message: error.message };
      });
  };
}
